import { useQuery } from '@tanstack/react-query';
import { portalApi } from '@/lib/api/portal.js';
import { formatCurrency, formatDateTime } from '@/lib/format.js';

export function PortalLoyaltyPage() {
  const loyaltyQuery = useQuery({
    queryKey: ['portal', 'loyalty'],
    queryFn: portalApi.loyalty,
  });

  const data = loyaltyQuery.data as {
    pointsBalance: number | null;
    pointsValue: number | null;
    storeCreditBalance: string;
    recentTransactions: Array<{
      id: string;
      delta: number;
      balanceAfter: number;
      sourceType: string;
      createdAt: string;
    }>;
  } | undefined;

  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold">Loyalty & Credits</h1>
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <div className="text-xs font-bold uppercase text-slate-500">Loyalty Points</div>
          <div className="mt-2 text-3xl font-bold text-[#1B4F8A]">
            {data?.pointsBalance ?? '—'}
          </div>
          {data?.pointsValue != null ? (
            <p className="mt-1 text-sm text-slate-500">Worth {formatCurrency(data.pointsValue)}</p>
          ) : null}
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <div className="text-xs font-bold uppercase text-slate-500">Store Credit</div>
          <div className="mt-2 text-3xl font-bold text-[#E8793A]">
            {formatCurrency(data?.storeCreditBalance ?? 0)}
          </div>
        </div>
      </div>

      <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <h2 className="text-sm font-bold uppercase tracking-wide text-slate-500">
          Recent Transactions
        </h2>
        <div className="mt-3 divide-y divide-slate-100">
          {(data?.recentTransactions ?? []).map((tx) => (
            <div key={tx.id} className="flex justify-between py-3 text-sm">
              <div>
                <div className="font-semibold capitalize">{tx.sourceType.replace(/_/g, ' ')}</div>
                <div className="text-xs text-slate-400">{formatDateTime(tx.createdAt)}</div>
              </div>
              <div className={tx.delta >= 0 ? 'font-semibold text-green-700' : 'font-semibold text-red-600'}>
                {tx.delta >= 0 ? '+' : ''}
                {tx.delta}
              </div>
            </div>
          ))}
          {(data?.recentTransactions ?? []).length === 0 ? (
            <p className="py-6 text-center text-sm text-slate-500">No loyalty activity yet.</p>
          ) : null}
        </div>
      </section>
    </div>
  );
}
